import config from '@feature-config/core/connectivity/feature.config.json';
import { createFeatureModule } from '../../createFeatureModule';
import type { FeatureModule } from '../../types';
import { ConnectivityFeature } from './ConnectivityFeature';

const connectivityFeature: FeatureModule = createFeatureModule(
  config,
  ConnectivityFeature,
  'core/connectivity'
);

export default connectivityFeature;
